var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container',{staticClass:"main-content-container px-0",attrs:{"fluid":""}},[(!_vm.userIsCustomer)?_c('order-wrapper'):_c('request-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }